// extracted by mini-css-extract-plugin
export default {"root":"Plugs_root__NYttq","box":"Plugs_box__nDjpW","text":"Plugs_text__1t8Gv","childrenBox":"Plugs_childrenBox__p41-b","progress":"Plugs_progress__weQ4k"};